import { useEffect } from 'react';
import { useDataCertificationsContext } from '../stores/data-certifications-context';

function useDataCertificationsLoading(): void {
  const { fetchData } = useDataCertificationsContext();

  useEffect(() => {
    fetchData();
  }, [fetchData]);
}

export default useDataCertificationsLoading;
